import { environment } from 'src/environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgOtpInputModule } from 'ng-otp-input';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SocketIoModule, SocketIoConfig, Socket } from 'ngx-socket-io';
import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth-layout/login/login.component';
import { SingupComponent } from './auth-layout/singup/singup.component';
import { CmsLayoutComponent } from './cms-layout/cms-layout.component';
import { FooterComponent } from './cms-layout/footer/footer.component';
import { HeaderComponent } from './cms-layout/header/header.component';
import { HomeComponent } from './cms-layout/page/home/home.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { SidebarNavComponent } from './main-layout/pages/sidebar-nav/sidebar-nav.component';
import { P404ErrorComponent } from './errors/404.component';
import { P419ErrorComponent } from './errors/419.component';
import { P500ErrorComponent } from './errors/500.component';
import { P401ErrorComponent } from './errors/401.component';
import { OtpVerificationComponent } from './auth-layout/otp-verification/otp-verification.component';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { NgxCaptchaModule } from 'ngx-captcha';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgxHowlerService } from 'ngx-howler';
import { TimezoneService } from './services/timezone.service';

// import { AboutUsComponent } from './cms-layout/page/about-us/about-us.component';
// import { ContactUsComponent } from './cms-layout/page/contact-us/contact-us.component';
// import { HowWeWorkComponent } from './cms-layout/page/how-we-work/how-we-work.component';
import { OnlineStatusModule } from 'ngx-online-status';
import { SpeedTestModule } from 'ng-speed-test';
import { TypewriterComponent } from './cms-layout/page/home/typewriter/typewriter.component';
import { SharedModule } from './shared.module';
import { SellerOnboardComponent } from './auth-layout/seller-onboard/seller-onboard.component';
import localeIn from '@angular/common/locales/en-IN';
import { TagInputModule } from 'ngx-chips';
const config: SocketIoConfig = {
  url: environment.SOCKET_URL,
  options: {
    // path: '/socket.io',
    // transports: ['websocket']
  },
};

const ERROR_COMPONENTS = [
  P404ErrorComponent,
  P419ErrorComponent,
  P500ErrorComponent,
  P401ErrorComponent,
];
// 2. REGISTER THE DATA
registerLocaleData(localeIn);
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SingupComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    CmsLayoutComponent,
    SidebarNavComponent,
    MainLayoutComponent,
    OtpVerificationComponent,
    TypewriterComponent,
    ...ERROR_COMPONENTS,
    SellerOnboardComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      progressBar: true,
      newestOnTop: false,
      disableTimeOut: false,
    }),
    NgxSpinnerModule,
    HttpClientModule,
    NgOtpInputModule,
    ModalModule.forRoot(),
    SocketIoModule.forRoot(config),
    NgxCaptchaModule,
    CarouselModule,
    NgxSkeletonLoaderModule,
    SpeedTestModule,
    //Add import OnlineStatusModle from ngx-online-status package.
    OnlineStatusModule,
    SharedModule,
    TagInputModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    NgxHowlerService,
    TimezoneService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(ngxHowlerService: NgxHowlerService) {
    ngxHowlerService.loadScript(
      'https://cdnjs.cloudflare.com/ajax/libs/howler/2.2.0/howler.min.js',
    );
  }
}
